import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface VideoDialogData {
  videoUrl: string;
  title: string;
}

@Component({
    selector: 'app-contents-video-modal',
    templateUrl: './contents-video-modal.component.html',
    styleUrls: ['./contents-video-modal.component.scss'],
    standalone: false
})
export class ContentsVideoModalComponent implements OnInit, OnDestroy {
  safeVideoUrl: SafeResourceUrl | null = null;

  constructor(
      private sanitizer: DomSanitizer,
      public dialogRef: MatDialogRef<ContentsVideoModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: VideoDialogData
  ) {}

  ngOnInit(): void {
    if (this.data?.videoUrl) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.videoUrl);
    }
  }

  ngOnDestroy(): void {
    this.safeVideoUrl = null;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
